import React, { useState, useEffect } from 'react';
import BreakCrumbs from '../../components/BreakCrumbs';
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Divider,
} from '@material-ui/core';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import TableLoading from '../../components/TableLoading';
import { alertError } from '../../Util/Util';
import TableEmpty from '../../components/TableEmpty';
import { useHistory } from 'react-router-dom';
import { LIST_PAGE_COUNT } from '../../data/common';
import StoreTable from '../../components/Stores/StoreTable';
import storeAPI from '../../middleware/storeAPI';

const StoreList = (props) => {
  const { match } = props;
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [stores, setStores] = useState();
  const [storeTotal, setStoreTotal] = useState();
  const [page, setPage] = useState(1);

  useEffect(() => {
    handleSearch();
  }, [page]);

  const handleSearch = () => {
    setIsLoading(true);

    storeAPI
      .getStores(page, LIST_PAGE_COUNT)
      .then(
        (rs) => {
          setStores(rs.storeList);
          setStoreTotal(rs.totalCount);
        },
        (error) => {
          alertError(error);
        },
      )
      .then(() => {
        setIsLoading(false);
      });
  };

  const toEditStore = (id) => {
    history.push(`/Stores/Store/${id}`);
  };

  const toCreateStore = () => {
    history.push('/Stores/Store');
  };

  return (
    <div className="popular pagefadeIn">
      <BreakCrumbs path={match.url}></BreakCrumbs>

      <Box component={Paper} square elevation={2} p={1} mt={3} mb={3}>
        <Grid
          container
          direction="row"
          justify="space-around"
          alignItems="center">
          <Grid item xs>
            <Typography variant="h4" color="textPrimary" gutterBottom>
              分店列表
            </Typography>
          </Grid>

          <Grid item xs style={{ marignLeft: 'auto' }}>
            <div style={{ textAlign: 'right' }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<AddCircleOutlineOutlinedIcon />}
                disabled={isLoading}
                onClick={toCreateStore}>
                建立分店
              </Button>
            </div>
          </Grid>
        </Grid>

        <Divider light />

        {isLoading && <TableLoading />}

        {!isLoading && !stores && <TableEmpty message="無分店" />}

        {!isLoading && stores && (
          <StoreTable
            stores={stores}
            page={page}
            setPage={setPage}
            total={storeTotal}
            toEditStore={toEditStore}
          />
        )}
      </Box>
    </div>
  );
};

export default StoreList;
